import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../Context/AuthContext';

function PrivateRoute({children}) {
    const { user } = useContext(AuthContext);

    return !user ? <Navigate to='/login'/> : <Outlet/>;
}

export default PrivateRoute;
